import { useState } from 'react';

const faqs = [
  {
    q: '韩漫网址是免费的吗？',
    a: '是的，本站所有漫画内容均可免费在线浏览，无需付费即可阅读全部章节。',
  },
  {
    q: '需要注册账号才能阅读吗？',
    a: '不需要。打开任意漫画即可直接阅读，收藏功能使用浏览器本地存储实现，无需账号。',
  },
  {
    q: '收藏的漫画会同步到其他设备吗？',
    a: '不会。收藏数据仅保存在当前浏览器的本地存储中，更换设备或清理浏览器数据后会丢失。',
  },
  {
    q: '为什么有些内容显示为演示？',
    a: '本站当前为演示版本，暂未接入真实漫画接口，播放与下载相关功能尚未开放，请勿误解为可离线下载。',
  },
  {
    q: '可以下载漫画离线观看吗？',
    a: '暂不支持下载与离线观看功能。我们专注于提供流畅的在线阅读体验。',
  },
  {
    q: '如何反馈问题或提交建议？',
    a: '你可以通过页面下方的反馈表单提交，我们会认真阅读每一条建议。',
  },
];

export default function FaqAccordion() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <div className="space-y-3">
      {faqs.map((f, i) => {
        const isOpen = open === i;
        return (
          <div
            key={f.q}
            className="overflow-hidden rounded-lg border border-background-200/80 bg-background-50"
          >
            <button
              type="button"
              onClick={() => setOpen(isOpen ? null : i)}
              className="flex w-full items-center justify-between gap-4 px-4 py-3.5 text-left cursor-pointer"
            >
              <span className="text-sm font-medium text-foreground-900">{f.q}</span>
              <i
                className={`shrink-0 text-lg text-primary-500 transition-transform ${
                  isOpen ? 'ri-subtract-line' : 'ri-add-line'
                }`}
              />
            </button>
            {isOpen && (
              <p className="border-t border-background-200/80 px-4 py-3.5 text-sm leading-relaxed text-foreground-600 animate-fade-in">
                {f.a}
              </p>
            )}
          </div>
        );
      })}
    </div>
  );
}